import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Table, Button, Divider, Card, Drawer, Popconfirm, Dropdown, Menu, Icon } from 'antd';
import FormRegistro from './FormRegistro';
import { notificacao } from '../master-page/redux/actions';
import { TopoPagina } from '../componentes';

export class DefaultPage extends Component {
  static propTypes = {
    loginSap: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      drawerVisible: false,
    };
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.listar({ order: 'TransacaoSAP ASC' });
  }
  componentDidUpdate(prevProps) {
    const { loginSap, actions } = this.props;

    if (prevProps.loginSap.buscarLoginSapPending && !loginSap.buscarLoginSapPending) {
      if (loginSap.buscarLoginSapError) {
        notificacao('error', 'Falha ao buscar registro.');
      } else {
        this.setState({ drawerVisible: true });
      }
    }
    if (prevProps.loginSap.salvarPending && !loginSap.salvarPending) {
      if (loginSap.salvarError) {
        notificacao('error', 'Falha ao salvar registro.');
      } else {
        notificacao('success', 'Registro salvo.');
        this.closeDrawer();
        actions.listar({ order: 'TransacaoSAP ASC' });
      }
    }
    if (prevProps.loginSap.deletarPending && !loginSap.deletarPending) {
      if (loginSap.deletarError) {
        notificacao('error', 'Falha ao excluir registro.');
      } else {
        notificacao('success', 'Registro excluído.');
      }
    }
  }

  handleSubmit = form => {
    const { loginSap } = this.props;

    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }
      this.salvarRegistro({ ...loginSap.registroLoginSap, ...values });
    });
  };

  salvarRegistro = registro => {
    const { actions } = this.props;

    actions.salvar(registro);
  };
  deleteConfirm = registro => {
    const { actions } = this.props;

    actions.deletar(registro);
  };

  showDrawer = registro => {
    const { actions } = this.props;

    if (registro) {
      actions.buscarLoginSap({ where: { id: registro.id } });
    } else {
      this.setState({ drawerVisible: true });
    }
  };
  closeDrawer = () => {
    const { actions } = this.props;

    actions.inicializarRegistroLoginSap();
    this.setState({ drawerVisible: false });
  };

  render() {
    const { loginSap } = this.props;
    const { drawerVisible } = this.state;

    const colunas = [
      {
        title: 'Transação SAP',
        dataIndex: 'TransacaoSAP',
        key: 'TransacaoSAP',
        // sorter: (a, b) => this.sorterColumn(a, b, 'TransacaoSAP'),
      },
      {
        title: 'Login',
        dataIndex: 'SAP_User',
        key: 'SAP_User',
        // sorter: (a, b) => this.sorterColumn(a, b, 'SAP_User'),
      },
      {
        title: 'Ambiente',
        dataIndex: 'SAP_Ambiente',
        key: 'SAP_Ambiente',
        // sorter: (a, b) => this.sorterColumn(a, b, 'SAP_Ambiente'),
      },
      {
        title: 'Ações',
        dataIndex: '',
        key: 'x',
        render: (text, record) => {
          return (
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item key="1" onClick={() => this.showDrawer(record)}>
                    Editar
                  </Menu.Item>
                  <Menu.Item key="2">
                    <Popconfirm
                      title="Confirma exclusão do registro?"
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={() => this.deleteConfirm(record)}
                    >
                      Excluir
                    </Popconfirm>
                  </Menu.Item>
                </Menu>
              }
            >
              <Button>
                Ações <Icon type="down" />
              </Button>
            </Dropdown>
          );
        },
      },
    ];

    return (
      <div className="login-sap-default-page">
        <TopoPagina titulo="Configurações de Login SAP">
          <Button onClick={() => this.showDrawer()} type="primary" icon="form">
            Novo Cadastro
          </Button>
        </TopoPagina>
        <div className="containerPage">
          <div className="containerConteudo">
            <Table
              dataSource={loginSap.listaLoginSap}
              columns={colunas}
              size="small"
              bordered
              style={{ paddingTop: '15px' }}
              loading={loginSap.buscarLoginSapPending}
            />
          </div>
        </div>

        <Drawer
          placement="right"
          visible={drawerVisible}
          title="Cadastro de Login SAP"
          onClose={() => this.closeDrawer()}
          width={'50vw'}
          closable={false}
          destroyOnClose={true}
        >
          <Card
            extra={
              <React.Fragment>
                <Button onClick={() => this.closeDrawer()} type="primary" icon="rollback">
                  Cancelar
                </Button>
                <Divider type="vertical" />
                <Button
                  onClick={() => this.formRef.props.onSubmit()}
                  type="primary"
                  icon="save"
                  loading={loginSap.salvarPending}
                >
                  Salvar
                </Button>
              </React.Fragment>
            }
          >
            <FormRegistro
              registro={loginSap.registroLoginSap}
              submitForm={this.handleSubmit}
              formRef={el => (this.formRef = el)}
            />
          </Card>
        </Drawer>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    loginSap: state.loginSap,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/login-sap/DefaultPage.js